import { X } from '@phosphor-icons/react'
import {
  ComponentProps,
  forwardRef,
  Fragment,
  MouseEventHandler,
  useMemo,
} from 'react'

import { buildDateQuestionList } from '@/components/CalculationComponent/utils'
import { Question } from '@/types'
import cn from '@/utils/tailwind/cn'

import { DropdownInfoModel, HandleSelectQuestionProps } from '../..'
import { Dropdown } from '../Dropdown'

type Props = ComponentProps<typeof Dropdown.Root> & {
  onClose: MouseEventHandler<HTMLButtonElement>
  dropdownInfo?: DropdownInfoModel
  onSelectQuestion: (
    title: string,
    value: string | number,
    props?: HandleSelectQuestionProps
  ) => void
  questions: Question[]
}

export const DateQuestionDropdown = forwardRef<HTMLDivElement, Props>(
  (
    { className, dropdownInfo, onClose, onSelectQuestion, questions, ...props },
    ref
  ) => {
    const options = useMemo(() => buildDateQuestionList(questions), [questions])
    return (
      <Dropdown.Root
        className={cn(
          'min-w-[288px]',
          ['addDateField'].includes(dropdownInfo?.dataType || '') && 'block'
        )}
        ref={ref}
        {...props}
      >
        <Dropdown.CloseButton onClick={onClose}>
          <X className="text-xs text-white" weight="bold" />
        </Dropdown.CloseButton>
        <Dropdown.List>
          {options?.length ? (
            options.map(({ title, value, disabled, formIndex }) => (
              <Fragment key={value}>
                <Dropdown.ListItem>
                  <Dropdown.ListItemButton
                    className="flex w-full flex-col items-start gap-1 px-2.5 py-2 text-gray-800 outline-none hover:bg-gray-100/80 focus:outline-none disabled:cursor-not-allowed [&:disabled>span]:text-gray-400"
                    disabled={disabled}
                    onClick={() =>
                      onSelectQuestion(title, value, { formIndex })
                    }
                  >
                    {title}
                  </Dropdown.ListItemButton>
                </Dropdown.ListItem>
              </Fragment>
            ))
          ) : (
            <Dropdown.ListItem>
              <Dropdown.ListItemButton className="!cursor-default hover:bg-white">
                No questions
              </Dropdown.ListItemButton>
            </Dropdown.ListItem>
          )}
        </Dropdown.List>
        <Dropdown.Footer>Click on the name to select the field</Dropdown.Footer>
      </Dropdown.Root>
    )
  }
)
